// export type UserRole = 'ADMIN_RESPONSIBLE' | 'ADMIN_COMMON' | 'PDU_PERFORMER';

import { SupportChatItemDto } from '@common/generated-api/models/support-chat-item-dto';
import { SupportChatListDto } from '@common/generated-api/models/support-chat-list-dto';
import { SupportChatStateForm } from '@common/generated-api/models/support-chat-state-form';

export enum UserRoles {
  'ADMIN_RESPONSIBLE' = 'ADMIN_RESPONSIBLE',
  'ADMIN_COMMON' = 'ADMIN_COMMON',
  'PDU_PERFORMER' = 'PDU_PERFORMER',
}

export enum CompanyTypes {
  'PRODUCER' = 'PRODUCER',
  'DISTRIBUTOR' = 'DISTRIBUTOR',
  'CLIENT' = 'CLIENT',
}

export enum UserTypes {
  'DISTRIBUTOR' = 'DISTRIBUTOR',
  'CLIENT' = 'CLIENT',
  'PDU_PERFORMER' = 'PDU_PERFORMER',
}

export interface ISupportRequest extends SupportChatListDto {
  selected: boolean;
}

  export const SupportRequestStates: { [P in SupportChatItemDto['state']]: P } = {
  SUPPORT_CLOSED: 'SUPPORT_CLOSED',
  SUPPORT_NEW: 'SUPPORT_NEW',
  SUPPORT_OPEN: 'SUPPORT_OPEN',
}
